import React, { useState } from "react";
// import Model from '../Model/ImgUploadModel'
// Libraries
import styled from "styled-components";
import tw from "twin.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import "antd/dist/antd.css";
import ImgCrop from "antd-img-crop";
import { Upload as Uploader, message } from "antd";
import { Modal } from "antd";
import { bgGlobalColor } from "../../pages";

const Container1 = styled.div`
  ${tw`
 mt-3
 py-2
 bg-frame-xgray
 rounded-lg
`}
`;

const Section1 = styled.div`
  ${tw`
    flex
    gap-4
  `}
`;

const Heading1 = styled.h1`
  ${tw`
  font-normal
  pl-4
  text-left
  mt-2
  text-color-bright
 `}
  font-size: 1.5rem;
`;

const Description = styled.div`
  ${tw`
  w-3/4
  text-sm
  text-frame-gray
  font-normal
  col-span-2
  py-2
  pl-4
  text-left
  mb-2
  leading-4
  `}
`;

const ButtonContainer = styled.span`
  ${tw`
    pl-0
  `}
`;

const Button = styled.button`
  ${tw`
    font-normal
    mb-2
    rounded-full
    h-12 w-12
    justify-center
    bg-color-bright
    border-none
    outline-none
  `}
`;

const Upload = ({
  setUploadedImage,
  setHeight,
  setWidth,
  setUploadedLogoImage,
}) => {
  const [visible, setVisible] = useState(false);
  const handleCancel = () => {
    setVisible(false);
  };
  const handleopen = () => {
    setVisible(true);
  };

  const [fileList, setFileList] = useState([]);

  // const onChange = ({ fileList: newFileList }) => {
  //   console.log('e123456789test7412589630', fileList)

  //   setFileList(newFileList);
  //   console.log('e------', newFileList)
  // };

  // const onPreview = async (file) => {
  //   const src = file.url || (await getSrcFromFile(file));
  //   const imgWindow = window.open(src);

  //   if (imgWindow) {
  //     const image = new Image();
  //     image.src = src;
  //     imgWindow.document.write(image.outerHTML);
  //   } else {
  //     window.location.href = src;
  //   }
  // };
  return (
    <>
      {/* <Model /> */}
      <Container1 style={{ background: bgGlobalColor }}>
        <Heading1 style={{ fontWeight: "500", color: "#fff" }}>
          {" "}
          Upload Profile Pic
        </Heading1>
        <Section1>
          <Description
            style={{ color: "#fff", fontSize: "13px", lineHeight: "18px" }}
          >
            Click on the upload icon to upload profile pic. You can repeat this
            step to choose another profile pic.
          </Description>
          <div>
            <ButtonContainer>
              <Button onClick={handleopen}>
                <label htmlFor="contained-button-file">
                  <FontAwesomeIcon
                    icon={faUpload}
                    style={{ color: "#000", fontSize: "23px" }}
                  />
                </label>
              </Button>
            </ButtonContainer>
          </div>
        </Section1>
      </Container1>

      <Modal
        visible={visible}
        title="Upload Profile Pic"
        // onOk={handleOk}
        onCancel={handleCancel}
      >
        <ImgCrop
          grid
          aspect={1}
          rotate
          id={"contained-button-file"}
          onModalOk={(e) => {
            if (e) {
              console.log("e----", URL.createObjectURL(e));

              console.log(
                URL.createObjectURL(e),
                "FFFFFFFFFURL.createObjectURL(e)"
              );
              setVisible(false);
              setUploadedLogoImage(URL.createObjectURL(e));
              const i = new Image();
              i.onload = function () {
                const imageDimensions = [
                  {
                    height: i.height,
                    width: i.width,
                  },
                ];
                setHeight(imageDimensions[0].height);
                setWidth(imageDimensions[0].width);
              };

              i.src = URL.createObjectURL(e);
            }
          }}
        >
          <Uploader
            listType="picture-card"
            showUploadList={false}
            // fileList={fileList}
            // onChange={onChange}
            // onPreview={onPreview}
          >
            {fileList.length < 1 && " + Upload"}
          </Uploader>
        </ImgCrop>
      </Modal>
    </>
  );
};

export default Upload;
